import { CenteredCircularProgress } from '../common/CenteredCircularProgress';
import { Box } from '@mui/material';
import { AiChat, ChatShort } from '../common/ai-chat/aiChatTypes';
import { NoResults } from '../documentation/shared/NoResults';
import { useChatSections } from './useChatSections';
import ChatsSectionLayout from './ChatsSectionLayout';
import AiAgentChatListItemSearch from './AiAgentChatListItemSearch';

const convertToShorChat: (items?: AiChat[]) => ChatShort[] | undefined = (items) =>
  items?.map((item) => ({ isLoading: false, ...item }));

const AiAgentSearchResults = ({
  isLoadingSearch,
  searchResults,
  searchText,
  activeChatId,
  setActiveChatId,
}: {
  isLoadingSearch: boolean;
  searchResults?: AiChat[];
  searchText?: string;
  activeChatId?: string;
  setActiveChatId: (id: string) => Promise<void>;
}) => {
  const noResults = !!searchText && !isLoadingSearch && searchResults && searchResults.length === 0;
  const sections = useChatSections(convertToShorChat(searchResults));

  if (noResults) {
    return (
      <Box pr={1} pl={2}>
        <NoResults />
      </Box>
    );
  }
  return (
    <>
      {isLoadingSearch && <CenteredCircularProgress />}
      {!isLoadingSearch &&
        sections.map((section) =>
          section.items.length > 0 ? (
            <ChatsSectionLayout key={section.title} title={section.title}>
              {section.items.map((chatItem) => {
                const relevantChat = searchResults?.find((result) => result.id === chatItem.id);
                if (!relevantChat) return null;
                return (
                  <AiAgentChatListItemSearch
                    key={relevantChat.id}
                    chat={relevantChat}
                    isActive={activeChatId === relevantChat.id}
                    onClick={() => setActiveChatId(relevantChat.id)}
                  />
                );
              })}
            </ChatsSectionLayout>
          ) : null,
        )}
    </>
  );
};

export default AiAgentSearchResults;
